module.exports = __webpack_public_path__ + "static/media/FousaEnP.edca158b.png";